// @module Finis.FinisAging.aging
define("Finis.FinisAging.aging.View", [
  "finis_finisaging_aging.tpl",

  "Finis.FinisAging.aging.SS2Model",

  "Backbone",
], function (
  finis_finisaging_aging_tpl,

  agingSS2Model,

  Backbone
) {
  "use strict";

  // @class Finis.FinisAging.aging.View @extends Backbone.View
  return Backbone.View.extend({
    template: finis_finisaging_aging_tpl,

    initialize: function (options) {
      const self = this;
      this.model = new agingSS2Model();
      this.fetchAndRender();

      Backbone.on("refreshAgingData", function () {
        self.fetchAndRender();
      });
    },

    fetchAndRender: function () {
      const self = this;
      this.model.fetch().done(function () {
        const attrs = self.model.attributes;
        self.aging = attrs.agingPreferences?.data?.results;
        self.overDue = attrs.overduePreferences?.data?.results;
        self.render();
      });
    },

    events: {},

    bindings: {},

    childViews: {},

    //@method getContext @return Finis.FinisAging.aging.View.Context
    getContext: function getContext() {
      const aging = this.aging;
      const overDue = this.overDue;
      // Over Due Popup
      if (aging) {
        const accountId = this.aging.internalid;
        function setCookie(name, value, hours) {
          var date = new Date();
          date.setTime(date.getTime() + hours * 60 * 60 * 1000);
          var expires = "expires=" + date.toUTCString();
          document.cookie = name + "=" + value + ";" + expires + ";path=/";
        }
        function getCookie(name) {
          var nameEQ = name + "=";
          var ca = document.cookie.split(";");
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0)
              return c.substring(nameEQ.length, c.length);
          }
          return null;
        }

        var modalShown = getCookie("isPastDuePopUp_" + accountId);
        if (aging.overduebalance > 0 && !modalShown) {
          $("#past-due-modal").modal("show");
          setCookie("isPastDuePopUp_" + accountId, "true", 24);
        }
      }
      // Overudue indicator
      if (overDue) {
        const isEU = window.location.href.indexOf("finisswim.eu") > -1;
        const current = this.aging["Current"];
        const onetothirtydays = this.aging["1-30 Days"];
        const thirtytosixtydays = this.aging["30-60 Days"];
        const sixtytoninetydays = this.aging["60-90 Days"];
        const overninetydays = this.aging["Over 90 Days"];
        // const totalAmountDue = this.aging["overduebalance"]

        let formattedNumber = overDue.overduebalance.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        $(function () {
          $(".current").text((isEU ? "€" : "$") + current);
          $(".onetothirtydays").text((isEU ? "€" : "$") + onetothirtydays);
          $(".thirtytosixtydays").text((isEU ? "€" : "$") + thirtytosixtydays);
          $(".sixtytoninetydays").text((isEU ? "€" : "$") + sixtytoninetydays);
          $(".overninetydays").text((isEU ? "€" : "$") + overninetydays);
          $(".totalamountdue").text((isEU ? "€" : "$") + formattedNumber);
        });

        if (overDue.overduebalance > 0) {
          let formattedNumber = overDue.overduebalance.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          $(".balance-indicator-details-past-due-value").text(
            (isEU ? "€" : "$") + formattedNumber
          );
        } else {
          $(".balance-indicator-details-past-due-value").text(
            isEU ? "€0.00" : "$0.00"
          );
        }
        let dueBalancePercentage;
        const creditLimit = overDue.creditlimit ? overDue.creditlimit : 0;
        const overdueBalance = overDue.overduebalance
          ? overDue.overduebalance
          : 0;

        if (creditLimit > 0 && overdueBalance > 0) {
          dueBalancePercentage = (overdueBalance / creditLimit) * 100;
          if (dueBalancePercentage > 100) {
            dueBalancePercentage = 100;
          }
        } else if (creditLimit === 0 && overdueBalance > 0) {
          dueBalancePercentage = 100;
        } else {
          dueBalancePercentage = 0;
          $(".balance-indicator-bar-past-due-progress").css("border", 0);
        }
        $(".balance-indicator-bar-past-due-progress").css(
          "width",
          dueBalancePercentage + "%"
        );
        if (overDue.balance == 0) {
          $(".balance-indicator-bar-progress").css("border", 0);
        }
      }

      return {};
    },
  });
});
